import { render, staticRenderFns } from "./BmWmsCodeIndex.vue?vue&type=template&id=8e12d97c&scoped=true&"
import script from "./BmWmsCodeIndex.vue?vue&type=script&lang=js&"
export * from "./BmWmsCodeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e12d97c",
  null
  
)

export default component.exports